const iStickyNav = {
    el: $('.I-js-search-sticky-nav'),
    link: $('.I-js-scrollTop'),
    searchbox: $('.immo-js-main-search-form'),
    init() {
        if (this.link.length > 0) {
            this.bindEvents();
            this.scrollEvents();
        }
    },

    bindEvents() {
        this.link.on('click', (e) => {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: 0,
            }, 500);
        });
    },

    scrollEvents() {
        $(window).on('scroll', () => {
            if ($(window).scrollTop() >= this.searchbox.offset().top + this.searchbox.height()) {
                this.el.addClass('sticky');
            } else {
                this.el.removeClass('sticky');
            }
        });
    },
};

export default iStickyNav;
